document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.shop-all-card__swatch');
  if (!swatch || !swatch.dataset.variantId) return;

  const card = swatch.closest('.shop-all-card');
  if (!card) return;

  card.querySelectorAll('.shop-all-card__swatch').forEach(el => {
    el.classList.remove('shop-all-card__swatch--active');
  });

  swatch.classList.add('shop-all-card__swatch--active');

  const input = card.querySelector('.product-variant-id');
  if (input) {
    input.value = swatch.dataset.variantId;
  }

  // Hide Add to Cart when variant is not available
  const available = swatch.dataset.available === 'true';
  const submit = card.querySelector('.quick-add__submit');
  if (submit) {
    submit.disabled = !available;
    submit.classList.toggle('is-sold-out', !available);
    const label = submit.querySelector('.quick-add__label');
    if (label) label.textContent = available ? submit.dataset.addText : submit.dataset.soldOutText;
  }
  if (input) input.disabled = !available;
});



document.addEventListener('click', function (e) {
  const variant = e.target.closest('.shop-all-card__variant');
  if (!variant) return;

  const card = variant.closest('.shop-all-card');
  if (!card) return;

  // Active variant
  card.querySelectorAll('.shop-all-card__variant').forEach(item => {
    item.classList.remove('shop-all-card__variant--active');
  });
  variant.classList.add('shop-all-card__variant--active');

  // Update selected size text in label
const selectedLabel = card.querySelector('.shop-all-card__variant-selected');
if (selectedLabel && variant.dataset.size) {
  selectedLabel.textContent = variant.dataset.size;
} 

  // Update variant id for Add to Cart
  const input = card.querySelector('.product-variant-id');
  if (input) {
    input.value = variant.dataset.variantId;
  }

  // Update Add to Cart button availability
  const submit = card.querySelector('.quick-add__submit');
  if (submit && variant.dataset.available !== undefined) {
    const available = variant.dataset.available === 'true';
    submit.disabled = !available;
    if (input) input.disabled = !available;
    const label = submit.querySelector('.quick-add__label');
    if (label) {
      label.textContent = available ? submit.dataset.addText : submit.dataset.soldOutText;
    }
  }

  // Update price
  const salePrice = card.querySelector('.shop-all-card__price-sale');
  if (salePrice) {
    salePrice.textContent = variant.dataset.price;
  }

  // Update compare price
  const comparePrice = card.querySelector('.shop-all-card__price-compare');

  if (comparePrice) {
    if (variant.dataset.comparePrice) {
      comparePrice.textContent = variant.dataset.comparePrice;
      comparePrice.style.display = '';
    } else {
      comparePrice.style.display = 'none';
    }
  }
  
  // Update first image
  const imgUrl = variant.dataset.varintImg;
  const firstImg = card.querySelector('.product-first-image img')

  if (firstImg && imgUrl) {
    const widths = [180, 360, 540, 720, 900, 1080, 1296, 1365];

    const srcset = widths
      .map((w) => {
        const u = new URL(imgUrl, window.location.origin);
        u.searchParams.set("width", w);
        return `${u.href} ${w}w`;
      })
      .join(", ");

    firstImg.src = imgUrl;
    firstImg.srcset = srcset;
  }
});

// const observer = new MutationObserver(() => {
//   const navList = document.querySelector('.shop-all-nav__list');
//   const activeTab = document.querySelector('.shop-all-nav__pill--active');

//   if (navList && activeTab) {
//     navList.scrollLeft = activeTab.offsetLeft - 20;
//     observer.disconnect();
//   } 
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });